import React from 'react';
import { cx } from '../cx';

// 선택 카드 ChoiceCard (D-09 미등재 — 신규 추가, 표준문서 정비 대상) — 클릭 전용 선택 카드.
// 파일 입력이 아니라 "여러 방법 중 하나를 눌러 진행"하는 화면용. 외형은 Upload(.dropzone) 와 같은 규격(.choice-card*).
// 클릭 영역은 네이티브 <button> — Enter/Space·포커스 링·disabled 를 브라우저가 처리한다.
// 우상단 배지 슬롯(badge)에는 <Badge status="accent">추천</Badge> 처럼 Badge 를 넣는다.
// highlight: 선택·추천 강조 링(--gt-primary 2px).
export interface ChoiceCardProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  /** 카드 제목 */
  title: React.ReactNode;
  /** 설명(주 문구) — <strong> 은 굵게 표시됨 */
  description?: React.ReactNode;
  /** 보조 문구(작은 글자) */
  hint?: React.ReactNode;
  /** 아이콘 슬롯 — 80px 칩 안에 표시, stroke="currentColor" svg 권장 */
  icon?: React.ReactNode;
  /** 우상단 배지 슬롯 — Badge 사용 */
  badge?: React.ReactNode;
  /** 선택 강조 링 */
  highlight?: boolean;
}

export const ChoiceCard = React.forwardRef<HTMLButtonElement, ChoiceCardProps>(function ChoiceCard(
  { title, description, hint, icon, badge, highlight = false, disabled = false, className = '', type, ...props },
  ref,
) {
  return (
    <div className={cx('choice-card', highlight && 'is-highlight', disabled && 'is-disabled', className)}>
      {badge != null && <span className="choice-card-badge">{badge}</span>}
      <button ref={ref} type={type ?? 'button'} className="choice-card-body" disabled={disabled} {...props}>
        {icon != null && <span className="choice-card-icon">{icon}</span>}
        <span className="choice-card-text">
          <span className="choice-card-title">{title}</span>
          {description != null && <span className="choice-card-desc">{description}</span>}
          {hint != null && <span className="choice-card-hint">{hint}</span>}
        </span>
      </button>
    </div>
  );
});
